import { MobXProviderContext } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import React from 'react';

import RootStore from '../stores/RootStore';

export const useStores = (): { store: Instance<typeof RootStore> } => {
    return React.useContext(MobXProviderContext as React.Context<any>);
};
